import { useFeatureFlagStore } from "./useFeatureFlagStore";

/**
 * Returns whether the current user has the given feature flag enabled.
 * Defaults to `false` until verdicts load (and on any backend error).
 *
 *   const showRemix = useFeatureFlag("remix_flow");
 */
export function useFeatureFlag(flagKey: string): boolean {
  return useFeatureFlagStore((s) => s.flags[flagKey] === true);
}
